<template>
  <Modal
    header="Vi saknar ditt telefonnummer"
    confirmText="Spara"
    loadingText="Sparar"
    size="sm"
    :addSpace="false"
    :disabled="!isValid"
    :loading="isSaving"
    @confirm="submit"
  >
    <div class="flex flex-col gap-4">
      <p class="text-b2">Ibland kan vi behöva kontakta dig via telefon. Fyll i ditt telefonnummer för att fortsätta.</p>

      <Input
        id="phoneMobile"
        label="Telefonnummer"
        v-model="phoneMobile"
        type="tel"
        rule-type="required"
        placeholder="Ange ditt telefonnummer"
        :floatingLabel="true"
        @keyup.enter="submit"
      />

      <p class="text-danger" v-if="errormsg">{{ errormsg }}</p>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/ui/modal';
import Input from '@/components/ui/form/input';
import { mapGetters } from 'vuex';

export default {
  name: 'ForcePhoneModal',
  components: { Modal, Input },
  data() {
    return {
      phoneMobile: '',
      isSaving: false,
      errormsg: null,
    };
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
    }),
    isValid() {
      return !!this.phoneMobile && this.phoneMobile.trim().length >= 6;
    },
  },
  methods: {
    submit() {
      if (!this.isValid || this.isSaving) return;

      this.isSaving = true;
      this.errormsg = null;
      if(this.profile.defaultPhone && this.profile.defaultPhone.toLowerCase() === 'unknown') {
        this.profile.defaultPhone = 'phoneMobile';
      }

      const updatedProfile = {
        ...this.profile,
        phoneMobile: this.phoneMobile.trim(),
        defaultPhone: this.profile.defaultPhone || 'phoneMobile',
      };
    console.log("saving profile", updatedProfile);
      return this.$store
        .dispatch('saveProfile', updatedProfile)
        .then(() => this.$store.dispatch('fetchProfile'))
        .then(() => {
          this.$emit('close');
        })
        .catch(() => {
          console.log('error saving profile');
          this.errormsg = 'Något gick fel, försök igen.';
        })
        .finally(() => {
          this.isSaving = false;
          if(!this.errormsg){
            this.$emit('close');
          }
        });
    },
  },
};
</script>
